export const noopLogger = {};
